import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'

import CardContent from '@mui/material/CardContent'
import { VendorCompleteProfile } from '../profileCards/vendor/VendorCompleteProfile'
import { VendorPublicProfile } from '../profileCards/vendor/VendorPublicProfile'
import { setProfileModalOpen, updateProfile } from '../../features/authSlice'
import styles from './venderSettingTabs.module.scss'
import { VendorPublicProfileTop } from '../profileCards/vendor/VendorPublicProfileTop'
import { toastHelper } from '../../util/toastHelper'
import { ALL_STACKS } from '../../util/constants'
import { getImageFilesValidationError } from '../../util/imageUploadValidation'

import { useVendorOrPlannerSubscriptionAccess } from '../../hooks'

export const BusinessSettings = () => {
	const dispatch = useDispatch()

	const user = useSelector((state) => state.auth.user)
	const modalOpen = useSelector((state) => state.auth.profileModalOpen)
	const subscriptionAccess = useVendorOrPlannerSubscriptionAccess()
	const [formData, setFormData] = useState({
		imageMediaMap: {},
		images: [],
		media: [],
		businessTypes: [],
		maxCapacity: 200,
		numEmployees: 100,
		instagramLink: '',
		tiktokLink: '',
		facebookLink: '',
		websiteLink: '',
		services: [],
		businessDescription: '',
	})
	// Calculate initial step based on actual user data from Redux
	const calculateStepFromUser = (u) => {
		if (!u) return 0
		if (
			u.businessTypes?.length > 0 ||
			u.customBusinessType
		) {
			if (u.businessDescription) {
				if (u.numEmployees) {
					if (u.services && u.services.length > 0) {
						if (u.maxCapacity) {
							if (u.media && u.media.length > 0) {
								return 7
							}
							return 6
						}
						return 5
					}
					return 4
				}
				return 3
			}
			return 2
		}
		return 0
	}

	const [modalStep, setModalStepState] = useState(() =>
		calculateStepFromUser(user)
	)

	const setModalOpen = (val) => {
		dispatch(setProfileModalOpen(val))
	}

	const setModalStep = (val) => {
		let newStep = val
		if (typeof val === 'function') {
			newStep = val(modalStep)
		}
		setModalStepState(newStep)
	}

	const handleFileChange = (e, type) => {
		if (type === 2) {
			const files = Array.from(e.target.files || [])
			if (!files.length) return

			const validationError = getImageFilesValidationError(files)
			if (validationError) {
				return toastHelper(validationError, 'error')
			}

			const maxPhotos = subscriptionAccess?.maxMedia || 1
			setFormData((prev) => {
				let nextMedia = [...prev.media]
				let nextMap = { ...prev.imageMediaMap }
				for (const file of files) {
					if (nextMedia.length >= maxPhotos) break
					const fileURL = URL.createObjectURL(file)
					nextMedia.push(fileURL)
					nextMap[fileURL] = file
				}
				return {
					...prev,
					containsImage: 'media',
					media: nextMedia,
					imageMediaMap: nextMap,
				}
			})
			return
		}

		const file = e.target.files[0]

		if (!file) return

		const validationError = getImageFilesValidationError([file])
		if (validationError) {
			return toastHelper(validationError, 'error')
		}
		const fileURL = URL.createObjectURL(file)

		if (type === 0) {
			// business profile picture
			dispatch(
				updateProfile({
					containsImage: 'businessProfilePic',
					imageMediaMap: { [fileURL]: file },
				})
			)
		} else if (type === 1) {
			// background cover picture
			dispatch(
				updateProfile({
					containsImage: 'coverPic',
					imageMediaMap: { [fileURL]: file },
				})
			)
		}
	}

	useEffect(() => {
		const businessTypes = user.businessTypes?.filter((item) => !!item?.trim())
		setFormData({
			businessAddress: user.businessAddress,
			businessName: user.businessName,
			media: user.media,
			businessTypes,
			customBusinessType: user.customBusinessType || '',
			numEmployees: user.numEmployees,
			instagramLink: user.instagramLink,
			tiktokLink: user.tiktokLink,
			facebookLink: user.facebookLink,
			websiteLink: user.websiteLink,
			services: user.services,
			maxCapacity: user.maxCapacity,
			businessDescription: user.businessDescription,
			profileCompleted: user.profileCompleted,
			imageMediaMap: {},
			images: [],
		})
	}, [user])

	return (
		<div className={styles.tabPreviewWrp}>
			<div className={styles.businessSettingTab}>
				<VendorPublicProfileTop
					handleFileChange={handleFileChange}
					user={user}
				/>
				<div className={styles.bottomContent}>
					<CardContent className={styles.bottomContentInner}>
						{(() => {
							if (user.profileCompleted) {
								return (
									<VendorPublicProfile
										editable={true}
										canEditBusinessDetails={user?.__t === 'vendor'}
										formData={formData}
										handleFileChange={handleFileChange}
										setFormData={setFormData}
									/>
								)
							} else {
								return (
									<VendorCompleteProfile
										formData={formData}
										handleFileChange={handleFileChange}
										setFormData={setFormData}
										modalOpen={modalOpen}
										setModalOpen={setModalOpen}
										modalStep={modalStep}
										setModalStep={setModalStep}
									/>
								)
							}
						})()}
					</CardContent>
				</div>
			</div>
		</div>
	)
}
